import type { FC, ReactNode } from 'react'
import type { PostSummary } from '@/types'

import { cn } from '@/lib/utils'
import { PostCard } from '@/components/blog/post-card'

interface PostGridProps {
    posts: PostSummary[]
    headingLevel?: 'h2' | 'h3'
    className?: string
}

export const PostGrid: FC<PostGridProps> = ({ posts, headingLevel = 'h2', className }): ReactNode => {
    return (
        <div className={cn('grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3 lg:gap-x-10', className)}>
            {posts.map((post, index) => (
                <PostCard
                    key={post.id}
                    post={post}
                    headingLevel={headingLevel}
                    priority={index < 3}
                    className='animate-in fade-in slide-in-from-bottom-3 fill-mode-both duration-700 motion-reduce:animate-none'
                />
            ))}
        </div>
    )
}
